import { ZuschlagRabatt } from '@/types/service-response'

export class ProjectBookingBelegZuschlagRabatt {
  public constructor (
    readonly Rabatt: string | null, //double
    readonly RabbatKontoId: number | null,
    readonly Zuschlag: string | null, //double
    readonly ZuschlagKontoId: number | null,
    readonly Versandspesen: string | null //double
  ) {}

  static createFromResponse (responseData: ZuschlagRabatt): ProjectBookingBelegZuschlagRabatt {
      return new ProjectBookingBelegZuschlagRabatt(
        responseData.Rabatt !== null ? responseData.Rabatt.toFixed(2) : null,
        responseData.RabbatKontoId,
        responseData.Zuschlag !== null ? responseData.Zuschlag.toFixed(2) : null,
        responseData.ZuschlagKontoId,
        responseData.Versandspesen !== null ? responseData.Versandspesen.toFixed(2) : null,
      )
  }
}
